import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from 'hooks';
import { LoginPath } from './Paths';

interface PrivateRouteProps extends RouteProps {
    component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
    component: Component, 
    ...rest 
}) => {
    const auth = useAuth();
    const isAuthenticated = auth && auth.signedIn && auth.user && auth.token;
    
    // Temporary bypass for dashboard development - Change to false when backend is ready
    const isDevelopmentBypass = false;

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated || isDevelopmentBypass ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: LoginPath,
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;